import {Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef} from '@angular/core';

@Component({
    selector: 'hint',
    templateUrl: './hint.component.html',
    styleUrls: ['./hint.component.scss']
})
export class HintComponent implements OnInit {
    @Input() data: any;
    @Input() parentElementSelector: string;
    @Input() index: number;
    @Output() onOutline = new EventEmitter<number>();

    public isDirectionTop: boolean = false;
    public isShow: boolean = false;

    private parentRect;
    private element;

    constructor(private elementRef: ElementRef) {
    }

    ngOnInit() {
        if (this.parentElementSelector) {
            this.parentRect = document.querySelector(this.parentElementSelector).getBoundingClientRect();
            this.element = this.elementRef.nativeElement;
        }
    }

    public toggle() {
        this.isShow = !this.isShow;

        this.isDirectionTop = this.index > 7;

        const difference: number = this.getOverflowBottomDifference();
        if (difference > 0) {
            this.onOutline.emit(difference);
        }
    }

    @HostListener('document:click', ['$event.target'])
    private hide(targetElement: HTMLElement): void {
        if (!this.elementRef.nativeElement.contains(targetElement)) {
            this.isShow = false;
        }
    }

    private getOverflowBottomDifference(): number {
        if (this.parentRect) {
            const maxHeight = this.parentRect.bottom;

            const elementReact = this.element.getBoundingClientRect();
            const elementHeight = this.element.querySelector('.hint').getBoundingClientRect().height;
            const elementBottomPosition = elementReact.bottom + elementHeight;

            if (elementBottomPosition > maxHeight) {
                return Math.round(elementBottomPosition - maxHeight);
            }
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/admin/themes/hint/hint.component.ts